import { defineTrackViewedPercentageSchema } from "~/components/schema-render/common/track-viewed-percentage/schemas";

export const NumberOfReadableElementInPaywall = 3;

export const PlusCustomContents = [
  defineTrackViewedPercentageSchema({
    percentage: "0",
    row: 0,
  }),
  defineTrackViewedPercentageSchema({
    percentage: "20",
    row: 5,
  }),
  defineTrackViewedPercentageSchema({
    percentage: "50",
    row: 11,
  }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
    row: -1,
  }),
];
